import { usePlaybackCurrentTs } from '@app/core/playback/hooks/usePlayback';
import { useVideoPlaybackState } from '@app/core/playback/video/useVideoPlaybackState';
import { Box, Button } from '@mui/material';
import { useEffect } from 'react';
import FormattedDuration from 'react-intl-formatted-duration';
import { FormattedMessage } from 'react-intl';
import { FrameSetButton } from './FrameSetButton';

/**
 * Controls for selecting a video frame.
 * Shows the selection button or the selected time.
 */
export function FrameSetControls({
  time,
  onSelect,
  unit,
}: {
  time: number | null;
  onSelect: (time: number | null) => void;
  unit?: 'seconds' | 'ms';
}) {
  const currentTs = usePlaybackCurrentTs();
  const videoJsPlayer = useVideoPlaybackState((s) => s.videoJsPlayer);

  // Reset selection when player time changes (on play or seek)
  useEffect(() => {
    onSelect(null);
  }, [currentTs]);

  // Set to first frame on load
  useEffect(() => {
    videoJsPlayer?.currentTime(0);
  }, [videoJsPlayer]);

  return (
    <Box mt={2}>
      {time === null ? (
        <FrameSetButton onSelect={onSelect} />
      ) : (
        <Button color={'primary'} variant="outlined" size="small" disabled>
          <FormattedMessage
            id="common.frameSelector.frameSelected"
            defaultMessage="Frame seleccionado:"
          />{' '}
          <FormattedDuration
            seconds={unit === 'seconds' ? time : time / 1000}
            unitDisplay={'narrow'}
          />
        </Button>
      )}
    </Box>
  );
}
